import * as React from 'react';
import { Tag } from '@components/atoms/tag';
import { TextStatusLineProps } from './text-status-line.types';

export const TextStatusLine: React.FC<TextStatusLineProps> = ({ children, status }) => {
	const { color, label } = status;
	return (
		<div data-testid="text-status-line" className="flex items-center gap-2">
			{children}
			<Tag color={color}>{label}</Tag>
		</div>
	);
};
